import common from './cs/common';
import nav from './cs/nav';
import footer from './cs/footer';
import home from './cs/home';
import catalog from './cs/catalog';
import product from './cs/product';
import cart from './cs/cart';
import checkout from './cs/checkout';
import auth from './cs/auth';
import account from './cs/account';
import orders from './cs/orders';
import articles from './cs/articles';
import faq from './cs/faq';
import legal from './cs/legal';
import errors from './cs/errors';

export default {
  common,
  nav,
  footer,
  home,
  catalog,
  product,
  cart,
  checkout,
  auth,
  account,
  orders,
  articles,
  faq,
  legal,
  errors,
};
